<template>
  <div>
    <div class="info-email" id="info-email-id">
      <div class="d-flex justify-content-center spinner" v-if="!thereIsData">
        <Loading size="200" />
      </div>

      <template v-if="thereIsData">
        <template
          v-if="
            this.currentDepartment.rol_name == 'superuser' &&
              $route.params.pathName == 'myQueue'
          "
        >
          <PageNotAllowed :busy="false" />
        </template>
        <template v-else>
          <template v-if="isBusy && $route.params.pathName == 'queue'">
            <PageNotAllowed :busy="true" />
          </template>
          <template v-else>
            <StickyEmail
              v-if="!item.message.entry_type.includes('Manual')"
              class="sticky-email"
              :content="stickyContent"
              :attachments="attachments"
              @resizeSticky="resizeSticky"
            />

            <h5><b>SUBJECT: </b>{{ item.message.subject }}</h5>
            <h6><b>Origin: </b>{{ item.message.entry_type }}</h6>
            <h6 v-if="currentDepartment.department_id == 1">
              <b>Language: </b>{{ item.message.language_classification }}
            </h6>
            <b-overlay
              v-if="$route.params.pathName == 'unknown'"
              :show="changingStatus"
              rounded
              opacity="0.6"
              spinner-small
              class="d-inline-block"
            >
              <b-button
                v-if="$route.params.pathName == 'unknown'"
                @click="changeStatus('queue')"
                :disabled="changingStatus"
                class="info-email__top-buttons--change-status"
                size="sm"
                >Send to Queue</b-button
              >
            </b-overlay>
            <b-overlay
              :show="sendingQuoteHC"
              rounded
              opacity="0.6"
              spinner-small
              class="d-inline-block"
              @hidden="onHidden"
            >
              <b-button
                v-if="
                  rolConditionInfoEmail(user, $route.params.pathName, item) &&
                    currentDepartment.department_id == 1
                "
                @click="sendToHypercubes"
                :disabled="sendingQuoteHC"
                ref="button-send-quote"
                class="info-email__trip--send-quote-button"
                >Send to <i class="fas fa-cube"></i
              ></b-button>
            </b-overlay>
            <div class="info-email__top-buttons">
              <b-overlay
                v-if="this.item"
                :show="changingStatusSent"
                rounded
                opacity="0.6"
                spinner-small
                class="d-inline-block"
              >
                <b-button
                  v-if="
                    ($route.params.pathName === 'queue' ||
                      $route.params.pathName === 'myQueue' ||
                      $route.params.pathName === 'alerts') &&
                      item.message.validation_alert &&
                      currentDepartment.department_id == 1
                  "
                  @click="changeStatus('sent')"
                  :disabled="changingStatus"
                  class="info-email__top-buttons--change-status"
                  size="sm"
                  >Send Alert to Sent</b-button
                >
              </b-overlay>
            </div>
            <div class="info-email__top-buttons">
              <b-overlay
                v-if="allowedSendToNonQuote"
                :show="changingStatus"
                rounded
                opacity="0.6"
                spinner-small
                class="d-inline-block"
              >
                <b-button
                  v-if="
                    allowedSendToNonQuote &&
                      (!item.message.validation_alert ||
                        !item.message.html_response)
                  "
                  @click="changeStatus('unknown')"
                  :disabled="changingStatus"
                  class="info-email__top-buttons--change-status"
                  size="sm"
                  >Send to Non {{ nameDepartment.toUpperCase() }}</b-button
                >
              </b-overlay>
              <b-button
                @click="changeContentStickyEmail"
                class="info-email__top-buttons--processed-email mr-2"
                size="sm"
                ><span v-if="originalEmail">Processed email</span
                ><span v-else>Original Email</span></b-button
              >

              <MessageHistory class="info-email__top-buttons history-button" />
            </div>

            <b-button
              v-if="
                currentDepartment.department_id == 1 &&
                  ($route.params.pathName === 'queue' ||
                    $route.params.pathName === 'myQueue')
              "
              @click="sendToSlack"
              :disabled="reportSent"
              class="info-email__top-buttons--report-slack mr-2"
              size="sm"
              ><img src="@/assets/images/slack.svg" alt="slack" />
              Report</b-button
            >

            <div
              class="info-email__tags"
              v-if="
                quoteTags &&
                  ($route.params.pathName === 'queue' ||
                    $route.params.pathName === 'myQueue' ||
                    $route.params.pathName === 'failed')
              "
            >
              <b-alert
                v-for="tag in quoteTags"
                :key="tag"
                variant="success"
                show
                ><b-icon icon="tags-fill" variant="success"></b-icon>
                {{ tag }}</b-alert
              >
            </div>

            <div
              v-if="!item.message.entry_type.includes('Manual')"
              class="info-email__message-body-mobile"
              v-html="stickyContent"
            ></div>

            <Trips v-model="tripsComponent" />

            <hr />

            <template
              v-if="
                (($route.params.pathName == 'sent' ||
                  $route.params.pathName == 'inProcess') &&
                  item.message.html_response != '' &&
                  item.message.html_response != null) ||
                  (($route.params.pathName == 'alerts' ||
                    $route.params.pathName == 'myQueue' ||
                    $route.params.pathName == 'queue') &&
                    item.message.html_response &&
                    item.message.validation_alert)
              "
            >
              <div
                v-html="item.message.html_response"
                class="info-email__html-sent"
                style="
                  text-align: justify;
                  text-justify: inter-word;
                  margin: 30px 15px;
                "
              ></div>
            </template>

            <div v-if="allowed" class="between-components">
              <EmailResponse
                v-if="currentDepartment.department_id == 1"
                :tripsComponent="tripsComponent"
                @getClientEmailsArray="getClientEmailsArray"
                @cannedSelected="InfocannedSelected"
                @cannedResponseChanged="changeCannedResponse"
                v-model="emailBody"
              />

              <EmailResponseOTR
                v-else
                @getCannedResponseTable="getCannedResponseTable"
                @getCannedResponseSelected="getCannedResponseSelected"
                :tripsComponent="tripsComponent"
                v-model="emailBody"
              />

              <b-overlay
                :show="sendingQuote"
                rounded
                opacity="0.6"
                spinner-small
                class="d-inline-block"
                @hidden="onHidden"
              >
                <span
                  v-b-tooltip.hover.light
                  :title="needsRecalculation ? 'Please confirm line items (Green Button) before sending the quote' : ''"
                  class="d-inline-block"
                >
                  <b-button
                    @click="sendQuote"
                    :disabled="sendingQuote || needsRecalculation"
                    ref="button-send-quote"
                    class="info-email__trip--send-quote-button"
                    :style="needsRecalculation ? 'pointer-events: none;' : ''"
                    >Send quote</b-button
                  >
                </span>
              </b-overlay>
            </div>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import StickyEmail from "./shared/StickyEmail";
import Trips from "./shared/Trips";
import PageNotAllowed from "@/components/PageNotAllowed";
import EmailResponse from "./shared/EmailResponse";
import EmailResponseOTR from "@/views/InfoEmail/EmailResponseOTR/Index";
import MessageHistory from "./shared/MessageHistory";
import {
  validationQuote,
  infoEmailCondition
} from "@/mixins/infoEmail/validateQuote";
import JSSoup from "jssoup";
import { missingFieldsAlert, errorAlert } from "@/api/errorMessages";
import { mapGetters } from "vuex";

export default {
  name: "InfoEmail",
  components: {
    Loading,
    EmailResponse,
    EmailResponseOTR,
    StickyEmail,
    PageNotAllowed,
    Trips,
    MessageHistory
  },
  data() {
    return {
      item: null,
      showMessageTags: false,
      trips: 0,
      tripsComponent: {
        pickupAndDelivery: [],
        accessorials: [],
        detailsTrip: [],
        items: []
      },
      thereIsOriginalEmail: true,
      stickyContent: String,
      stickyContentState: Number,
      stickyContentStatus: String,
      attachments: [],
      windowWidth: 0,
      thereIsData: false,
      user: null,
      isBusy: false,
      oldValueAux: null,
      hauls: [],
      tripAux: null,
      sendingQuote: false,
      sendingQuoteHC: false,
      emailBody: null,
      allowed: true,
      changingStatus: false,
      changingStatusSent: false,
      processedEmail: null,
      colors: {
        accessorials: "#ffe657",
        accessorials_delivery: "#ffe657",
        accesorials_pickup: "#ffe657",
        hu_count: "#c7b1d5",
        hu_count_small: "#c7b1d5",
        hu_count_id: "#c7b1d5",
        hu_count_tota: "#c7b1d5",
        sub_hu_count: "#c7b1d5",
        dimensions: "#fbd3d4",
        commodity: "#fcc79b",
        weight: "#f8a19a",
        weight_gross_and_net_per_unit: "#f8a19a",
        zip_to: "#ffe292",
        zip_from: "#b2ebf2",
        city_from: "#9cdcaa",
        city_to: "#adc8eB",
        volume_per_unit: "#8675a9",
        volume_total: "#8675a9",
        airport_pickup: "#E36481",
        airport_delivery: "#E36481",
        nmfc_class: "#FAC28B"
      },
      originalEmail: true,
      currentDepartment: null,
      allowedSendToNonQuote: false,
      thereIsCannedResponse: false,
      thereIsCannedIdResponseSelected: null,
      goSendHypercubes: false,
      assignedUser: null,
      disableEmailResponse: true,
      quoteTags: null,
      clientEmailsArray: null,
      nameDepartment: null,
      cannedResponseTables: null,
      cannedResponseSelected: null,
      reportSent: false,
      requiredKeyMessage: []
    };
  },
  computed: {
    sticky: function() {
      return this.$el.querySelector(".sticky-email");
    },
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapGetters("quotes", ["showActualQueue"]),
    ...mapGetters("quotes/commodity", ["showItemsTableFlag"]),
    needsRecalculation() {
      return this.currentDepartment.department_id == 1 && !this.showItemsTableFlag;
    }
  },
  watch: {
    windowWidth(newValue) {
      let infoEmail = this.$el.querySelector(".info-email");
      if (newValue < 992 && newValue > 841) {
        infoEmail.style.width = `calc(100% - 6% + 50px)`;
      } else if (newValue < 841 && newValue > 674) {
        infoEmail.style.width = `calc(100% - 6% + 40px)`;
      } else if (newValue < 674 && newValue > 507) {
        infoEmail.style.width = `calc(100% - 6% + 30px)`;
      } else if (newValue < 507 && newValue > 341) {
        infoEmail.style.width = `calc(100% - 6% + 20px)`;
      } else if (newValue < 341) {
        infoEmail.style.width = `calc(100% - 6% + 10px)`;
      } else if (newValue > 992) {
        infoEmail.style.width = `calc(100% - 30% + 60px)`;
      }
    },
    async showInfoDepartment(value) {
      this.currentDepartment = value;
      this.$router.push({
        name: "Emails",
        params: {
          pathName: "queue"
        }
      });
    }
  },
  async created() {
    let quoteId = this.$route.params.id;
    this.user = await this.$store.getters["login/showUserLoggedIn"];
    this.currentDepartment = this.showInfoDepartment;
    if (this.currentDepartment.department_id == 2) {
      this.nameDepartment = this.showActualQueue;
    } else {
      this.nameDepartment = this.currentDepartment.department_name;
    }
    await this.$store.dispatch("quotes/quote/getQuote", quoteId);
    this.item = await this.$store.getters["quotes/quote/showQuoteById"];
    this.$store.commit(
      "carrierCost/setInitTrailerSelectedInfo",
      this.item.haul.length
    );
    this.getQuoteTags();
    this.handlerEmailResponse();
    if (this.$route.params.pathName === "myQueue") {
      if (
        this.item.message.user === null ||
        this.item.message.charlie_status === 3 ||
        this.item.message.charlie_status === 4 ||
        this.item.message.charlie_status === 5 ||
        this.item.message.charlie_status === 8
      ) {
        this.swal({
          title: "There is something wrong!",
          text: `The quote doesn't belong to this queue`,
          icon: "error"
        });
        this.$router.push({
          name: "Emails",
          params: { pathName: "myQueue" }
        });
      }
    } else if (this.$route.params.pathName === "queue") {
      if (
        (this.item.message.user !== null ||
          this.item.message.charlie_status === 3 ||
          this.item.message.charlie_status === 4 ||
          this.item.message.charlie_status === 5 ||
          this.item.message.charlie_status === 8) &&
        this.currentDepartment.rol_name !== "superuser"
      ) {
        this.swal({
          title: "There is something wrong!",
          text: `The quote doesn't belong to this queue`,
          icon: "error"
        });
        this.$router.push({
          name: "Emails",
          params: { pathName: "queue" }
        });
      }
    } else if (this.$route.params.pathName === "inProcess") {
      if (
        this.item.message.charlie_status === 2 ||
        this.item.message.charlie_status === 4 ||
        this.item.message.charlie_status === 5 ||
        this.item.message.charlie_status === 8
      ) {
        this.swal({
          title: "There is something wrong!",
          text: `The quote doesn't belong to this queue`,
          icon: "error"
        });
        this.$router.push({
          name: "Emails",
          params: { pathName: "inProcess" }
        });
      }
    } else if (this.$route.params.pathName === "failed") {
      if (
        this.item.message.charlie_status === 2 ||
        this.item.message.charlie_status === 3 ||
        this.item.message.charlie_status === 5 ||
        this.item.message.charlie_status === 8
      ) {
        this.swal({
          title: "There is something wrong!",
          text: `The quote doesn't belong to this queue`,
          icon: "error"
        });
        this.$router.push({
          name: "Emails",
          params: { pathName: "failed" }
        });
      }
    } else if (this.$route.params.pathName === "sent") {
      if (
        this.item.message.charlie_status === 2 ||
        this.item.message.charlie_status === 3 ||
        this.item.message.charlie_status === 4 ||
        this.item.message.charlie_status === 8
      ) {
        this.swal({
          title: "There is something wrong!",
          text: `The quote doesn't belong to this queue`,
          icon: "error"
        });
        this.$router.push({
          name: "Emails",
          params: { pathName: "sent" }
        });
      }
    } else if (this.$route.params.pathName === "unknown") {
      if (this.item.message.is_quote !== false) {
        this.swal({
          title: "There is something wrong!",
          text: `The quote doesn't belong to this queue`,
          icon: "error"
        });
        this.$router.push({
          name: "Emails",
          params: { pathName: "unknown" }
        });
      }
    } else if (this.$route.params.pathName === "deleted") {
      if (this.item.message.is_deleted !== true) {
        this.swal({
          title: "There is something wrong!",
          text: `The quote doesn't belong to this queue`,
          icon: "error"
        });
        this.$router.push({
          name: "Emails",
          params: { pathName: "deleted" }
        });
      }
    }
    if (this.user[0].is_busy) {
      this.isBusy = true;
    }
    this.thereIsData = true;
    this.trips = this.item.haul.length;
    this.getEmailContent();
    if (!this.item.message.entry_type.includes("Manual")) {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    }
    this.unwatch = this.$store.watch(
      (state, getters) => getters["login/showUserLoggedIn"][0],
      (newValue, oldValue) => {
        this.oldValueAux = oldValue;
        if (newValue.is_busy) {
          this.isBusy = true;
        } else {
          this.isBusy = false;
        }
      }
    );
    if (
      this.$route.params.pathName == "myQueue" ||
      this.$route.params.pathName == "queue" ||
      (this.currentDepartment.department_id == 2 &&
        this.$route.params.pathName == "failed")
    ) {
      this.allowedSendToNonQuote = true;
    }
  },
  beforeDestroy() {
    this.unwatch();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    this.$store.commit("quotes/quote/setSelectedMode", null);
  },
  mounted() {
    /* if (this.$route.params.pathName == "failed") {
      if (this.item.message_state != "Successful Post-processing") {
        this.$bvToast.toast(`${this.item.message_state}`, {
          title: "Message Error",
          toaster: "b-toaster-top-right",
          variant: "danger",
          solid: true,
          static: true,
          noAutoHide: true,
        });
      }
    } */
    window.scrollTo(0, 0);
  },
  methods: {
    handlerEmailResponse() {
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      if (
        (this.currentDepartment.department_id == 1 &&
          this.currentDepartment.rol_name == "superuser" &&
          this.assignedUser == null) ||
        this.user[0].user.username == this.assignedUser
      ) {
        this.disableEmailResponse = false;
      }
      let allowedRoutes = ["myQueue", "failed", "queue", "alerts"];
      if (
        !allowedRoutes.includes(this.$route.params.pathName) ||
        (this.currentDepartment.rol_name == "quoter" &&
          this.$route.params.pathName == "queue") ||
        this.disableEmailResponse ||
        this.item.message.validation_alert
      ) {
        this.allowed = false;
      }
    },
    verifyQueueStatus() {
      if (
        (this.$route.params.pathName == "queue" ||
          this.$route.params.pathName == "myQueue") &&
        this.item.status != 2
      ) {
        this.showMessageError();
      }
      if (this.$route.params.pathName == "inProcess" && this.item.status != 3) {
        this.showMessageError();
      }
      if (this.$route.params.pathName == "failed" && this.item.status != 4) {
        this.showMessageError();
      }
      if (this.$route.params.pathName == "sent" && this.item.status != 6) {
        this.showMessageError();
      }
      if (this.$route.params.pathName == "unknown" && this.item.status != 1) {
        this.showMessageError();
      }
      if (this.$route.params.pathName == "deleted" && this.item.status != 9) {
        this.showMessageError();
      }
    },
    showMessageError() {
      this.swal({
        title: "There is something wrong!",
        text: `The quote doesn't belong to this queue`,
        icon: "error"
      });
      this.$router.push({
        name: "Emails",
        params: { pathName: "queue" }
      });
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    toggleOriginalEmail() {
      this.thereIsOriginalEmail = !this.thereIsOriginalEmail;
      if (!this.thereIsOriginalEmail) {
        document.getElementById("info-email-id").style.paddingRight = "1%";
        document.getElementById("float-id").style.right = "0";
      } else {
        document.getElementById("info-email-id").style.paddingRight = "26%";
        document.getElementById("float-id").style.right = "25%";
      }
    },
    handleMouseMove: function() {
      let stickyWidth = `calc(100% - ${event.pageX}px)`;
      let infoEmail = this.$el.querySelector(".info-email");
      if (event.pageX >= screen.width / 2) {
        this.sticky.style.width = stickyWidth;
        infoEmail.style.width = `calc(100% - ${stickyWidth} + 60px)`;
      }
    },
    resizeSticky: function() {
      this.$el.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", () => {
        this.$el.removeEventListener("mousemove", this.handleMouseMove);
      });
    },
    getEmailContent() {
      this.stickyContentState = 0;
      this.stickyContentStatus = "Original Email";
      this.stickyContent = this.item.message.content_html;
      this.attachments = this.item.message.attachments;
    },
    getClientEmailsArray(value) {
      this.clientEmailsArray = value;
    },
    changeCannedResponse(event) {
      this.thereIsCannedResponse = event;
    },
    InfocannedSelected(value) {
      this.thereIsCannedIdResponseSelected = value;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async sendQuote() {
      this.sendingQuote = true;
      let quoteId = this.$route.params.id;
      await this.$store.dispatch("quotes/quote/getQuote", quoteId);
      let validation = this.$store.getters["quotes/quote/showQuoteById"].haul;
      let sendQuote = validationQuote(validation);
      if (this.showActualQueue && this.showActualQueue === "drayage") {
        sendQuote = this.validateProviderInDrayage(sendQuote, validation);
      }
      if (sendQuote) {
        let sendQuoteFlag = true;
        let info = {};
        info.id = this.item.message.id;
        //this.$store.commit("cannedResponses/setCreateDetailsTable", true);
        await this.sleep(2000);
        if (
          this.currentDepartment.rol_name === "superuser" ||
          (this.currentDepartment.rol_name === "quoter" &&
            this.$route.params.pathName === "myQueue")
        ) {
          info.is_superuser = true;
        } else {
          info.is_superuser = false;
        }
        info.language = this.emailBody.language;
        if (this.currentDepartment.department_id == 1) {
          let itemsTableValidateFlag = this.showItemsTableFlag;
          sendQuoteFlag = false;
          info.html = `<div style='text-align: justify; text-justify: inter-word;'>${this.emailBody.messageBody}</div>`;
          if (!itemsTableValidateFlag) {
            missingFieldsAlert(
              "Please, Confirms line Items table standardization"
            );
            this.sendingQuote = false;
          } else if (!this.thereIsCannedResponse) {
            missingFieldsAlert("Please, select a canned response!");
            this.sendingQuote = false;
          } else {
            let activeEmailAlert = this.validateNmfcCalculator(validation);
            if (activeEmailAlert) {
              this.emailAlert(info);
            } else {
              missingFieldsAlert(
                "Please, validate that the nmfc calculated field is filled in."
              );
              this.sendingQuote = false;
            }
          }
          this.$store.commit("cannedResponses/setCreateDetailsTable", false);
        } else {
          let messageWithSignature = await this.addHtmlOtr();
          info.html = messageWithSignature[0];
          sendQuoteFlag = messageWithSignature[1];
          if (sendQuoteFlag) {
            for (let haul in validation) {
              const currentHaulId = validation[haul]?.id;
              let conditionLinearFeet = validation[haul].tms_mode.name.includes(
                "Partial"
              );
              if (!validation[haul].expected_cost) {
                missingFieldsAlert(
                  `Expected cost" field on trip ${parseInt(haul) +
                    1} is mandatory!`
                );
                sendQuoteFlag = false;
                this.sendingQuote = false;
                break;
              }
              if (!validation[haul].linear_feet && conditionLinearFeet) {
                missingFieldsAlert(
                  `"Linear feet" field on trip ${parseInt(haul) +
                    1} is mandatory!`
                );
                sendQuoteFlag = false;
                this.sendingQuote = false;
                break;
              }
              let rate =
                this.$store.getters["cannedResponsesModule/showRate"][haul]
                  ?.rate_usd ||
                this.$store.getters["cannedResponsesModule/showRate"][
                  currentHaulId
                ]?.rate_usd;
              if (rate) {
                let info = {};
                info.haulId = validation[haul].id;
                info.payload = {};
                info.payload.rate = rate;
                await this.$store.dispatch("quotes/haul/updateHaul", info);
              } else {
                missingFieldsAlert(
                  `"Rate" field on trip ${parseInt(haul) + 1} is mandatory!`
                );
                sendQuoteFlag = false;
                this.sendingQuote = false;
                break;
              }
            }
          } else {
            this.sendingQuote = false;
          }
        }
        if (this.currentDepartment.department_id !== 1 && sendQuoteFlag) {
          this.doSendQuote(info);
        }
      } else {
        this.sendingQuote = false;
      }
    },
    searchAndReziseImages(htmlContent) {
      let soupHtml = new JSSoup(htmlContent);
      let base64Images = soupHtml.findAll("img");
      if (base64Images.length > 0) {
        for (let img of base64Images) {
          if (img.attrs.style) {
            const imageSize = img.attrs.style
              .split("width:")[1]
              .split("p")[0]
              .trim();
            img.attrs.src = this.resizeImageBase64(
              img.attrs.src,
              parseInt(imageSize)
            );
          }
        }
      }
      return soupHtml.toString();
    },
    resizeImageBase64(originalImageBase64, maxWidth) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let img = new Image();
      img.src = originalImageBase64;
      let scale = maxWidth / img.width;
      let iwScaled = img.width * scale;
      let ihScaled = img.height * scale;
      canvas.width = iwScaled;
      canvas.height = ihScaled;
      ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
      let newBase64ImageResized = canvas.toDataURL("image/png", 1);
      return newBase64ImageResized;
    },
    async sendToHypercubes() {
      this.sendingQuoteHC = true;
      let routeName = this.$route.params.pathName;
      let quoteId = this.$route.params.id;
      await this.$store.dispatch("quotes/quote/getQuote", quoteId);
      let validation = this.$store.getters["quotes/quote/showQuoteById"].haul;
      for (let haul of validation) {
        if (haul.customer_id === null || haul.customer_id === "") {
          this.goSendHypercubes = false;
          break;
        } else {
          this.goSendHypercubes = true;
        }
      }
      let info = {};
      info.id = this.item.message.id;
      await this.sleep(2000);
      if (this.goSendHypercubes) {
        if (!this.thereIsCannedResponse) {
          missingFieldsAlert("Please, select a canned response!");
        } else {
          info.canned_id = this.thereIsCannedIdResponseSelected;
          let response = await this.$store.dispatch(
            "quotes/sendHyperCubes",
            info
          );
          if (!response) {
            this.swal({
              icon: "success",
              title: "Success",
              text: "Your quote has been sent",
              buttons: false,
              timer: 1000
            });
            this.$router.push({
              name: "Emails",
              params: { pathName: routeName }
            });
          } else if (response.status == 422) {
            errorAlert(
              "Error",
              "Please check the field information on all trips."
            );
          } else if (response.status == 400) {
            errorAlert("There is something wrong", response.data.detail.detail);
          } else if (response.status == 404) {
            errorAlert("There is something wrong", response.data.detail.detail);
          }
        }
        this.goSendHypercubes = false;
      } else {
        missingFieldsAlert("Customer field is required in all trips.");
      }
      this.$store.commit("cannedResponses/setCreateDetailsTable", false);
      this.sendingQuoteHC = false;
    },
    async changeStatus(type) {
      let response;
      if (type == "queue") {
        this.changingStatus = true;
        let quotes = [];
        quotes.push(this.item.id);
        response = await this.$store.dispatch("quotes/changeStatus", quotes);
      } else if (type == "unknown") {
        this.changingStatus = true;
        response = await this.$store.dispatch(
          "quotes/quote/sendToNonQuote",
          this.item.message.id
        );
      } else if (type == "sent") {
        this.changingStatusSent = true;
        let info = {};
        info.messageId = this.item.message.id;
        info.body = {
          charlie_status: 5
        };
        response = await this.$store.dispatch("quotes/updateMessage", info);
      }
      this.changingStatusSent = false;
      this.changingStatus = false;
      let pathNameAux = this.$route.params.pathName;
      if (response.status == 200) {
        this.$router.push({
          name: "Emails",
          params: { pathName: pathNameAux }
        });
      }
    },
    async changeContentStickyEmail() {
      this.originalEmail = !this.originalEmail;
      if (this.originalEmail) {
        this.stickyContent = this.item.message.content_html;
      } else {
        await this.renderContent();
        this.stickyContent = this.processedEmail;
      }
    },
    renderContent() {
      const email = JSON.parse(
        JSON.stringify(this.$store.getters["quotes/quote/showQuoteById"])
      );
      let content = email.message.content;
      let data = email.entity;
      for (let entity in data) {
        let currentEntity = data[entity];
        let entityValue = currentEntity.original_text;
        let initPos = currentEntity.start_interval;
        let finalPos = currentEntity.end_interval;
        if (initPos !== -1 && finalPos !== -1) {
          let category = currentEntity.category;
          let bgColor = this.colors[category];
          let html = this.createComponent(
            currentEntity.category,
            entityValue,
            bgColor
          );
          let extraLength = html.length - entityValue.length;
          let substring1 = content.substring(0, initPos);
          let substring2 = content.substring(finalPos);
          content = substring1 + html + substring2;
          this.updatePositions(data, extraLength, initPos);
        }
      }
      let styleContentAux = `<div style='word-spacing: 5px; letter-spacing: 1px; line-height: 35px;'>content-here</div>`;
      let styleContent = styleContentAux.replace("content-here", content);
      this.processedEmail = styleContent;
    },
    updatePositions: function(json, length, actualEntityUnit) {
      const data = json;

      for (let entity in data) {
        let currentEntity = data[entity];
        if (currentEntity.start_interval === actualEntityUnit) {
          currentEntity.end_interval = currentEntity.start_interval + length;
        } else if (currentEntity.start_interval > actualEntityUnit) {
          let difference =
            currentEntity.end_interval - currentEntity.start_interval;
          currentEntity.start_interval += length;
          currentEntity.end_interval =
            currentEntity.start_interval + difference;
        }
      }
    },
    createComponent: function(entity, entityValue, bgColor) {
      entity = entity.toUpperCase();
      let html = `
        <span style="background-color: ${bgColor}; border-radius: 8px; padding: 3px; vertical-align: middle">
            ${entityValue}
          <span><b>${entity}</b>
          </span>
        </span>&nbsp`;
      return html;
    },
    onHidden() {
      this.$refs["button-send-quote"].focus();
    },
    getQuoteTags() {
      if (this.item) {
        this.quoteTags = this.item.message.tag_email;
      }
    },
    async emailAlert(info) {
      if (this.clientEmailsArray == "" || this.clientEmailsArray == null) {
        this.swal("You are sending a quote without email, Are you sure?", {
          icon: "warning",
          buttons: true
        }).then(value => {
          if (value) {
            this.doSendQuote(info);
          } else {
            this.sendingQuote = false;
          }
        });
      } else {
        await this.doSendQuote(info);
      }
    },
    async doSendQuote(info) {
      this.info = info;
      this.validationLineItemUpdates = setInterval(
        this.getValidationsUpdate,
        1000
      );
    },
    async getValidationsUpdate() {
      this.commodityUpgradeValidation = this.$store.getters[
        "quotes/commodity/showRequestCompleted"
      ];
      this.haulUpgradeValidation = this.$store.getters[
        "quotes/haul/showRequestCompleted"
      ];
      if (this.commodityUpgradeValidation && this.haulUpgradeValidation) {
        clearInterval(this.validationLineItemUpdates);
        this.info.html = this.searchAndReziseImages(this.info.html);
        let response = await this.$store.dispatch(
          "quotes/sendQuote",
          this.info
        );
        if (response.status == 200) {
          if (this.currentDepartment.rol_name == "superuser") {
            this.$router.push({
              name: "Emails",
              params: { pathName: this.$route.params.pathName }
            });
          } else {
            this.$router.push({
              name: "Emails",
              params: { pathName: "myQueue" }
            });
          }
        }
        this.sendingQuote = false;
      }
    },
    rolConditionInfoEmail(user, pathName, item) {
      return infoEmailCondition(user, pathName, item);
    },
    getCannedResponseTable(cannedResponseTables) {
      this.cannedResponseTables = cannedResponseTables;
    },
    getCannedResponseSelected(cannedResponseSelected) {
      this.cannedResponseSelected = cannedResponseSelected;
    },
    replaceCannedResponseTable(justifyHtml, cannedResponseSelected) {
      let replacedTablesMessage = justifyHtml;
      for (let i = 0; i < this.cannedResponseTables.length; i++) {
        if (
          cannedResponseSelected === "DRAYAGE" ||
          cannedResponseSelected.includes("DRAYAGE")
        ) {
          if (this.cannedResponseTables[i].tableType === "rate") {
            replacedTablesMessage = replacedTablesMessage.replace(
              this.cannedResponseTables[i].tableId,
              this.cannedResponseTables[i].htmlTable
            );
          } else {
            replacedTablesMessage = replacedTablesMessage.replace(
              "{table_accessorials}",
              this.cannedResponseTables[i].htmlTable
            );
          }
        } else {
          if (this.cannedResponseTables[i].tableType === "freight-details") {
            replacedTablesMessage = replacedTablesMessage.replace(
              this.cannedResponseTables[i].tableId,
              this.cannedResponseTables[i].htmlTable
            );
          } else {
            replacedTablesMessage = replacedTablesMessage.replace(
              this.cannedResponseTables[i].tableId,
              this.cannedResponseTables[i].htmlTable
            );
          }
        }
      }
      return replacedTablesMessage;
    },
    validateSignatureKey() {
      if (this.currentDepartment.department_name.toLowerCase() === "ltl") {
        this.requiredKeyMessage = ["{hauls_info}", "{signature}"];
      } else if (
        this.cannedResponseSelected.toLowerCase().includes("drayage")
      ) {
        this.requiredKeyMessage = ["{table_accessorials}"];
        for (let i = 0; i < this.item.haul.length; i += 1) {
          this.requiredKeyMessage.push(`{table_rate_${i + 1}}`);
        }
      } else {
        for (let i = 0; i < this.item.haul.length; i++) {
          this.requiredKeyMessage.push(`{freight_details_trip_${i + 1}}`);
          this.requiredKeyMessage.push(`{quote_information_trip_${i + 1}}`);
        }
      }
      const allKeysPresent = this.includesAll(
        this.emailBody.messageBody,
        this.requiredKeyMessage
      );
      if (!allKeysPresent) {
        this.sendingQuote = false;
        missingFieldsAlert(
          `Please remember, keys must be put ${this.requiredKeyMessage} (paste with ctrl+shift+v)`
        );
        this.requiredKeyMessage = [];
        return false;
      }
      return true;
    },
    includesAll(str, arr) {
      return arr.every(word => str.includes(word));
    },
    async addHtmlOtr() {
      let canned = false;
      if (this.cannedResponseSelected) {
        let justifyHtmlAux = `<div style='text-align: justify; text-justify: inter-word;'>html-here</div>`;
        this.validateSignatureKey();
        let justifyHtml = justifyHtmlAux.replace(
          "html-here",
          this.emailBody.messageBody
        );
        justifyHtml = this.replaceCannedResponseTable(
          justifyHtml,
          this.cannedResponseSelected
        );
        await this.sleep(500);
        let userFullName =
          this.user[0].user.name + " " + this.user[0].user.surname;
        let title = this.user[0].user.title;
        let userPhone = this.user[0].user.phone;
        let userPhone1 = userPhone.slice(0, 3);
        let userPhone2 = userPhone.slice(3, 6);
        let userPhone3 = userPhone.slice(6);
        userPhone = "(" + userPhone1 + ") " + userPhone2 + "-" + userPhone3;
        let email = this.user[0].user.email;
        let signature = this.$store.getters[
          "cannedResponsesModule/showSignature"
        ].replace("username-here", userFullName.toUpperCase());
        signature = signature.replace("title-here", title);
        signature = signature.replace("userphone-here", userPhone);
        signature = signature.replace("email-here", email);
        let messageWithSignature = justifyHtml + signature;
        canned = true;
        return [messageWithSignature, canned];
      } else {
        missingFieldsAlert("Please, select a canned response!");
        this.sendingQuote = false;
        canned = false;
        return ["", canned];
      }
    },
    validateNmfcCalculator(hauls) {
      let counter = 0;
      for (let haul of hauls) {
        for (let commodity of haul.commodity) {
          if (!commodity.nmfc_calculated) {
            counter += 1;
          }
        }
      }
      if (counter > 0) {
        return false;
      } else {
        return true;
      }
    },
    async sendToSlack() {
      let route = this.$route.path;
      await this.$store.dispatch("quotes/reportSlack/getReport", route);
      this.reportSent = true;
    },
    validateProviderInDrayage(sendQuote, validation) {
      for (let haul in validation) {
        if (!validation[haul].drayage_provided_by) {
          this.swal("Please, Select a provider", {
            title: "Warning!",
            icon: "warning"
          });
          sendQuote = false;
        }
      }
      return sendQuote;
    }
  }
};
</script>

<style lang="scss" scoped>
.spinner {
  @include spinner;
}

.info-email {
  min-height: $view-height;
  @include padding-view(4.5%);

  &__top-buttons {
    display: inline-block;
    &--change-status {
      margin-right: 10px;
      @include primary-button;
    }
    &--processed-email {
      @include secondary-button;
    }
    &--report-slack {
      background-color: white;
      border-color: rgb(255, 255, 255);
      @include box-shadow;
      color: rgb(80, 80, 80);
      float: right;
      font-weight: bold;
      &:hover {
        background-color: rgb(230, 230, 230);
        border-color: rgb(230, 230, 230);
        color: rgb(80, 80, 80);
      }
      & img {
        width: 1.3rem;
      }
    }
  }

  &__tags {
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }

  &__message-body-mobile {
    display: none;
    @include box-shadow;
    border-radius: 4px;
    background-color: $color-white;
    padding: 20px;
    text-align: left;
    height: 200px;
    overflow-y: scroll;
    margin: $margin-most-used $margin-most-used/2;
    word-wrap: break-word;

    &::-webkit-scrollbar-track {
      background-color: #e9ecef;
      border-radius: 20px;
    }

    &::-webkit-scrollbar {
      width: 7px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  &__html-sent {
    font-size: 12px;
  }

  &__trip {
    &--send-quote-button {
      margin: 10px 15px;
      @include primary-button;
    }
  }
}

.between-components {
  margin-top: 15px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.alert {
  padding: 0.4rem 0.4rem;
  margin: 0.1rem;
  font-size: 12px;
  font-weight: 500;
}
@media (max-width: 991px) {
  .sticky-email {
    display: none;
  }

  .info-email__message-body-mobile {
    display: block;
  }
}
@media (max-width: 427px) {
  button {
    margin-bottom: 8px;
  }
  .info-email__top-buttons--report-slack {
    float: none;
    margin: 0.5rem;
  }
}
</style>
